
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'


import { Core } from '../core/core'
import { SE_CORE_MODULE_BUNDLE, SeCoreModule } from '../core/core.module'
import { SE_ICON_MODULE_BUNDLE, SeIconModule } from './../icon/icon.module'
import { SE_DIALOG_MODULE_BUNDLE, SeDialogModule } from './../dialog/dialog.module'

import { SeModalComponent } from './modal.component'

@NgModule({
  imports: [
	CommonModule, 
    SeCoreModule,
    SeIconModule,
    SeDialogModule,
  ],
  declarations: [
    SeModalComponent,
  ],
  exports: [
    SeModalComponent,
  ]
})
export class SeModalModule {}

const dependencies = [
  SE_CORE_MODULE_BUNDLE,
  SE_ICON_MODULE_BUNDLE,
  SE_DIALOG_MODULE_BUNDLE
]

export const SE_MODAL_MODULE_BUNDLE = `${Core.ANGULAR_MODULE}.modal`
export { SeModalAction, SeModalOptions, SeModalSize, SeModalComponent } from './index'

